import { render, staticRenderFns } from "./VuebaseLayout3.vue?vue&type=template&id=0cdc4402"
import script from "./VuebaseLayout3.vue?vue&type=script&lang=js"
export * from "./VuebaseLayout3.vue?vue&type=script&lang=js"
import style0 from "./VuebaseLayout3.vue?vue&type=style&index=0&id=0cdc4402&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports